import React from 'react';

const Logo = ({ style = {} }) => {
  return <img
    src="/image/logo-ag2r-header.svg"
    alt="logo"
    style={{ margin: 'auto', display: 'block', ...style }}
  />;
};

export default Logo;
